import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { OrganizationCloseStageRow } from "../organizationCloseStagesViewConfig";

export const OrganizationCloseStageUpdatedCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, OrganizationCloseStageRow, Date>) => (
        <span>{format(row.original.updatedAt, "MMM d, yyyy")}</span>
    ),
);
